import script from "./ContactButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactButton.vue?vue&type=script&setup=true&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=5d92205e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d92205e"]])

export default __exports__